// App.js
import React, { useState, useEffect } from 'react';
import { API_URL, ENDPOINTS } from '../../constants/api';
import ObjectTabs from './components/ObjectTabs';
import SqlSidebar from './components/SqlSidebar';
import { getToken } from '../../utils/TokenUtils';
import axios from 'axios';
import './css/SqlHome.css';
import SqlEditor from './components/Editor';
import image401 from '../../images/401.png';

const SqlHome = () => {
  const [dbObjects, setDbObjects] = useState({});
  const [selectedType, setSelectedType] = useState('Table');
  const [selectedObject, setSelectedObject] = useState(null);
  const token = getToken();
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({});

  const fetchData = async () => {
    try {

      const response = await axios.get(
        `${API_URL}/${ENDPOINTS.SYS}/getlink/ktc-sql`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      
        setPermissions(response.data?.permissions);
     

      setLoading(false);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      // notification.error({ message: error.message });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const loadDbObjects = async () => {
      const response = await axios.get(
        `${API_URL}/${ENDPOINTS.SQL}/get-db-objects`,
        {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        }
      );

      setDbObjects(response.data);
    };

    loadDbObjects();
  }, []);

  // console.log('dbObjects:', dbObjects);

if (
  !loading &&
  permissions?.can_view !== 1 &&
  permissions?.can_view !== true
) {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${image401})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
    </div>
  );
}
  return (
    <div className="" style={{ margin: 'auto', width: '95%' }}>
      <div className="row">
        <div className="col-2">
          {dbObjects && dbObjects.length > 0 && (
            <SqlSidebar
              dbObjects={dbObjects}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              setSelectedObject={setSelectedObject}
            />
          )}
        </div>
        <div className="col-10">
          <div className="main-content">
            {selectedObject ? (
              <ObjectTabs selectedObject={selectedObject} />
            ) : (
              <SqlEditor />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SqlHome;
